import { render, staticRenderFns } from "./PortBookingv2.vue?vue&type=template&id=3c4c92cc&scoped=true&"
import script from "./PortBookingv2.vue?vue&type=script&lang=js&"
export * from "./PortBookingv2.vue?vue&type=script&lang=js&"
import style0 from "./PortBookingv2.vue?vue&type=style&index=0&id=3c4c92cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c92cc",
  null
  
)

export default component.exports